import * as React from 'react';
import Project from 'src/entities/Project';
import CapTable from 'src/value-objects/CapTable';
import './Project.css';
import ImageContainer from 'src/modules/commons/images/Image.container';
import ProjectActionToolbarContainer from 'src/modules/project/partials/action-toolbar/ProjectActionToolbar.container';
import HtmlFormater from 'src/utils/htmlFormaterUtil';

interface Props {
  project: Project;
  capTable: CapTable;
  invest: boolean;
  closedProject: boolean;
}

const ProjectDetailsComponent: React.StatelessComponent<Props> = (props: Props) => (
  <div className="col-sm-9">
    <div className="padding-left-30">
      <div className="gap-50" />

      <h3>
        Detalles de la ronda
      </h3>
      <div className="gap-20" />
      <div className="row">
        <div>
          <div 
            className="from-rich-editor" 
            dangerouslySetInnerHTML={{ __html: HtmlFormater.parseMarkDownImages(props.project.roundDetails) }} 
          />
        </div>
        <table className="cap-table">
          <thead>
            <tr className="first-header">
              <td colSpan={2} />
              <th colSpan={2}>Si TCA alcanza el mínimo</th>
              <th colSpan={2}>Si TCA alcanza el máximo</th>
            </tr>
            <tr className="second-header">
              <th className="table-left">
                Inversores
            </th>
              <th>
                T. de inversión
            </th>
              <th className="table-right">
                Importe
            </th>
              <th className="table-right">
                %
            </th>
              <th className="table-right">
                Importe
            </th>
              <th className="table-right">
                %
            </th>
            </tr>
          </thead>
          <tbody>
            {props.capTable.investors.map(
              (investor, index) => (
                <tr key={index}>
                  <td className="table-left">
                    {investor.name}
                  </td>
                  <td>
                    {investor.investmentType}
                  </td>
                  <td className="table-right">
                    {investor.amountMin.toLocaleString('es')} €
                </td>
                  <td className="table-right">
                    {Number(investor.percentageMin.toFixed(2)).toLocaleString('es')}%
                </td>
                  <td className="table-right">
                    {investor.amountMax.toLocaleString('es')} €
                </td>
                  <td className="table-right">
                    {Number(investor.percentageMax.toFixed(2)).toLocaleString('es')}%
                </td>
                </tr>
              )
            )}
            <tr className="spacing-row">
              <td colSpan={6} />
            </tr>
            <tr>
              <td className="table-left">
                <strong>
                  Total
              </strong>
              </td>
              <td colSpan={1} />
              <td className="table-right">
                <strong>
                  {props.capTable.total.amountMin.toLocaleString('es')} €
              </strong>
              </td>
              <td className="table-right">
                <strong>
                  {Number(props.capTable.total.percentageMin.toFixed(2)).toLocaleString('es')}%
              </strong>
              </td>
              <td className="table-right">
                <strong>
                  {props.capTable.total.amountMax.toLocaleString('es')} €
              </strong>
              </td>
              <td className="table-right">
                <strong>
                  {Number(props.capTable.total.percentageMax.toFixed(2)).toLocaleString('es')}%
              </strong>
              </td>
            </tr>
            <tr>
              <td>
                Valoración Post-money
            </td>
              <td colSpan={1} />
              <td>
                {props.capTable.postMoneyValuation.postMoneyMin.toLocaleString('es')} €
            </td>
              <td colSpan={1} />
              <td>
                {props.capTable.postMoneyValuation.postMoneyMax.toLocaleString('es')} €
            </td>
              <td colSpan={1} />
            </tr>
          </tbody>
        </table>
        <div className="gap-40" />
        <div>
          <p className="featured c-black-text col-md-12">
            {props.project.highlightInvestorName}
          </p>
          {props.project.highlightInvestorImage ?
            <div className="col-md-4">
              <ImageContainer 
                style={{ margin: '0 auto', height: '200px' }}
                url={props.project.highlightInvestorImage.url}
              />
            </div> : null
          }
          <div className="col-md-8">
            <div
              className="from-rich-editor"
              dangerouslySetInnerHTML={{ __html: props.project.highlightInvestorDescription 
                ? HtmlFormater.parseMarkDownImages(props.project.highlightInvestorDescription) : '' }}
            />
          </div>
        </div>
      </div>
      <div className="gap-50"/>
      <ProjectActionToolbarContainer
        project={props.project}
        invest={props.invest}
        closedProject={props.closedProject}
      />
      <div className="gap-50" />
    </div>
  </div>
);

export default ProjectDetailsComponent;



// WEBPACK FOOTER //
// ./src/modules/project/partials/ProjectDetails.component.tsx